module.exports = __webpack_public_path__ + "img/icon-betrokken-in-regio.14cd36f85f197dd9a8a052c242fb8e4a.svg";